import { authHeader, ApiConfigs } from '../_helpers';

export const businessService = {
    getAll,
    getAllMinified,
    getById,
    update,
    deleteBusiness,
    getPage,
    ApprovedBusiness,
    DisapprovedBusiness,
    getAllApproved,
    getAllDisapproved,
    getApprovedByPage,
    getDisapprovedBypage,
    updatePermissions,
    getAllRequests,
    getCountAllRequests,
    UpdateBusinessRequestApproval,
    createBusiness,
    createUser,
    getUsersByBusinessID,
    search,
    deleteUser,
    getUserByID,
    updateUser,
    filterAdmin,
    filterBusiness,
    getServices
};

function getAllRequests() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getAllRequests}`, requestOptions).then(handleResponse);
}

function getCountAllRequests() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getCountAllRequests}`, requestOptions).then(handleResponse);
}
function UpdateBusinessRequestApproval(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.UpdateBusinessRequestApproval.replace(':id', id)}`, requestOptions).then(handleResponse);
}
function updatePermissions(permissions) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: permissions
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.updatePermissions}`, requestOptions).then(handleResponse);

}
function updateUser(user, id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: user
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.updateUser.replace(':id', id)}`, requestOptions).then(handleResponse);

}

function createBusiness(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: data
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.createBusiness}`, requestOptions).then(handleResponse);
}
function createUser(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: data
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.createUser}`, requestOptions).then(handleResponse);
}


function search(data) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },

    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.search.replace(':keyword', data)}`, requestOptions).then(handleResponse);
}


function getUsersByBusinessID(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getUserByBusinessID.replace(':id', id)}`, requestOptions).then(handleResponse);
}


function ApprovedBusiness(id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }

    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.ApprovedBusiness.replace(':id', id)}`, requestOptions).then(handleResponse);

}
function DisapprovedBusiness(id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.DisapprovedBusiness.replace(':id', id)}`, requestOptions).then(handleResponse);
}
function getAll() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getAll}`, requestOptions).then(handleResponse);
}
function getAllMinified() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getAllMinified}`, requestOptions).then(handleResponse);
}
function getAllApproved() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getAllApproved}`, requestOptions).then(handleResponse);
}
function getAllDisapproved() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getAllDisapproved}`, requestOptions).then(handleResponse);
}
function getPage(page) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getPage + page}`, requestOptions).then(handleResponse);
}
function getApprovedByPage(page) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getApprovedBypage + page}`, requestOptions).then(handleResponse);
}
function getDisapprovedBypage(page) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getDisapprovedBypage + page}`, requestOptions).then(handleResponse);
}

function deleteBusiness(id) {
    const requestOptions = {
        method: 'DELETE',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.deleteBusiness.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function deleteUser(id) {
    const requestOptions = {
        method: 'DELETE',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.deleteUser.replace(':id', id)}`, requestOptions).then(handleResponse);
}
function getUserByID(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getUserByID.replace(':id', id)}`, requestOptions).then(handleResponse);
}
function getById(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getById.replace(':id', id)}`, requestOptions).then(handleResponse);
}


function update(request, id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: request
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.update.replace(':id', id)}`, requestOptions).then(handleResponse);
}


function updateLocation(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.updateLocation}`, requestOptions).then(handleResponse);
}


function updateWorkingDays(workingDays) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(workingDays)
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.update_working_days}`, requestOptions).then(handleResponse);
}


function updateTranslations(translations) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(translations)
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.update_translations}`, requestOptions).then(handleResponse);
}


function getTranslations() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.get_translations}`, requestOptions).then(handleResponse);
}

function filterAdmin(payload){
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.filter.replace(':keyword', payload.keyword)}`, requestOptions).then(handleResponse);
}
    

function filterBusiness(request){
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },
    };
    console.log(request);
    return fetch('https://api-tn.liberrex.com/v1/admin/business/filter'+Keyword, requestOptions).then(handleResponse);
}


function getServices(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() },
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.getServices.replace(':id', id)}`, requestOptions).then(handleResponse);
}



function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}